import React from 'react'
import { useService } from '@pushly/aqe/lib/hooks'
import { Button, PageHeader } from '@pushly/aqe/lib/components'
import { DomainDto } from '../../dtos/domain'
import { AppService } from '../../services/index'
import { AppState } from '../../stores/app'
import { AbilityAction } from '../../enums/ability-action.enum'
import { asCaslSubject, CurrentUserCan, getDemoAttributesFor } from '../../stores/app-ability'
import { SubjectEntity } from '../../enums/ability-entity.enum'
import { FeedsDataView } from '@pushly/aqe/lib/components/feeds/feeds-data-view'
import { Domain } from '@pushly/models/lib/structs/domain'

const CREATE_FEED_ACTION_LABEL = 'Create Feed'

export const FeedsDataViewWrapper = (props: { domain: DomainDto; appState: AppState }) => {
    const appSvc = useService(AppService)

    const { appState } = props

    const feedSubject = () =>
        asCaslSubject(SubjectEntity.FEED, {
            domainId: props.domain.id,
            ...getDemoAttributesFor(props.domain, appState.currentDomain),
        })

    const canMutate = (): boolean => {
        return appState.abilityStore.can(AbilityAction.UPDATE, feedSubject())
    }

    // Feed create route lives under /feeds/new (see
    // src/features/domains/domains.tsx → FeedDataFormWrapper). It is grouped
    // with the /feeds list route, so the header "Create Feed" button targets the
    // /feeds-scoped create route.
    const newFeedPath = `/domains/${props.domain.id}/feeds/new`

    return (
        <div className="feeds-data-view-wrapper">
            <PageHeader
                title="Feeds"
                onTitleSet={appSvc.customizeTabTitle}
                action={
                    <CurrentUserCan do={AbilityAction.CREATE} on={feedSubject()}>
                        <Button
                            className="new-feed-button"
                            type="primary"
                            onClick={() => appSvc.route(newFeedPath)}
                            altHref={newFeedPath}
                        >
                            <span>{CREATE_FEED_ACTION_LABEL}</span>
                        </Button>
                    </CurrentUserCan>
                }
            />

            {/*
             * NOTE: `FeedsDataView` also exposes an optional internal `canCreate`
             * Create button. We intentionally do NOT pass `canCreate` so the single
             * header button above is the only Create affordance (no duplicate).
             */}
            <FeedsDataView
                hideRefresh={true}
                hideAutoRefreshOptions={true}
                domain={Domain.parseJsonObject(props.domain)}
                appSvc={appSvc}
                canMutate={canMutate}
                feedsPath={`/domains/${props.domain.id}/feeds`}
                userId={appState.currentUser?.id}
            />
        </div>
    )
}
